<template>
  <div class="home text-left">
    <h3 class="mb-3 text-left">Bienvenido a la administración de Bridge Bonds</h3>
    <div v-show="progress" class="text-center text-primary mt-3">
      <b-spinner class="align-middle"></b-spinner>
      <strong class="ml-2">Cargando...</strong>
    </div>
    <b-container v-if="counter">
      <b-row>
        <b-col lg="4" class="mb-3">
          <b-card
            class="shadow btn-card-color text-white"
         
          >
            <b-row>
              <b-col md="12">
                <b-row align-v="center">
                  <b-col class="text-center" md="12">
                    <v-icon class="text-center" name="user" scale="5"></v-icon>
                  </b-col>
                  <b-col md="12" class="text-left">
                    <p class="mb-2 py-0 text-center" style="font-size: 25px"><strong>USUARIOS</strong></p>
                    <p class="my-0 py-0">
                      <strong>Registrados: </strong
                      >{{ counter.users.total }}
                    </p>
                    <p class="my-0 py-0">
                      <strong>Administradores: </strong
                      >{{ counter.users.admin }}
                    </p>
                    <p class="my-0 py-0">
                      <strong>Clientes: </strong
                      >{{ counter.users.natural }}
                    </p>

                    <p class="my-0 py-0">
                      <strong>Activos: </strong
                      >{{ counter.users.active }}
                    </p>

                    <p class="my-0 py-0">
                      <strong>Desactivados: </strong
                      >{{ counter.users.inactive }}
                    </p>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
        <b-col lg="4" class="mb-3">
          <b-card class="shadow">
            <b-row>
              <b-col md="12">
                <b-row align-v="center">
                  <b-col md="12" class="text-center">
                    <v-icon name="wallet" scale="5"></v-icon>
                  </b-col>
                  <b-col md="12">
                    <p class="mb-2 py-0 text-center" style="font-size: 25px"><strong>COLOCACIONES</strong></p>
                    <p class="py-0 my-0">
                      <strong>Totales: </strong
                      >{{ counter.investments.total }}
                    </p>

                    <p class="py-0 my-0">
                      <strong>Aprobadas: </strong
                      >{{ counter.investments.verified }}
                    </p>
                    <p class="py-0 my-0">
                      <strong>Rechazadas: </strong
                      >{{ counter.investments.rejected }}
                    </p>
                    <p class="py-0 my-0">
                      <strong>Por aprobar: </strong
                      >{{ counter.investments.pending }} 
                    </p>
                    <p class="py-0 my-0">
                      <strong>Inversión actual: </strong>
                      ${{ counter.investments.actual_amount }}
                    </p>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
        <b-col lg="4" class="mb-3">
          <b-card class="card-color text-white" style="height: 100%;">
            <b-row>
              <b-col md="12">
                <b-row align-v="center">
                  <b-col md="12" class="text-center">
                    <v-icon class="mb-2" name="hand-holding-usd" scale="5"></v-icon>
                  </b-col>
                  <b-col md="12">
                    <p class="mb-2 py-0 text-center" style="font-size: 25px"><strong>RETIROS</strong></p>

                    <p class="py-0 my-0">
                      <strong>Total: </strong
                      >{{ counter.withdraws.total }}
                    </p>
                    <p class="py-0 my-0">
                      <strong>Aprobados: </strong
                      >{{ counter.withdraws.verified }}
                    </p>
                    <p class="py-0 my-0">
                      <strong>Por aprobar: </strong
                      >{{ counter.withdraws.pending }}
                    </p>
                    <p class="py-0 my-0">
                      <strong>Rechazados: </strong
                      >{{ counter.withdraws.rejected }}
                    </p>
                    <p class="py-0 my-0">
                      <strong>Pendiente: </strong
                      >${{ counter.withdraws.pending_amount }}
                    </p>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-card>
        </b-col>

        <b-col lg="4" class="mb-3">
          <b-card
            class="shadow"
          >
            <b-row>
              <b-col md="12">
                <b-row align-v="center">
                  <b-col md="12" class="text-center">
                    <v-icon name="coins" scale="5"></v-icon>
                  </b-col>
                  <b-col md="12">
                    <p class="mb-2 py-0 text-center" style="font-size: 25px">
                      <strong>DEPÓSITOS</strong>
                    </p>
                    <p class="my-0 py-0">
                      <strong>Totales: </strong
                      >{{ counter.reports.total }}
                    </p>

                    <p class="my-0 py-0">
                      <strong>Aprobados: </strong
                      >{{ counter.reports.verified }}
                    </p>

                    <p class="my-0 py-0">
                      <strong>Por aprobar: </strong
                      >{{ counter.reports.pending }}
                    </p>

                    <p class="my-0 py-0">
                      <strong>Rechazados: </strong
                      >{{ counter.reports.rejected }}
                    </p>
                    <p class="my-0 py-0">
                      <strong>Dinero pendiente: </strong
                      >${{ counter.reports.pending_amount }}
                    </p>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
        <b-col lg="4" class="mb-3">
          <b-card
            class="shadow card-color text-white"
            style="height: 100%;"
          >
            <b-row>
              <b-col md="12">
                <b-row align-v="center">
                  <b-col md="12" class="text-center">
                    <v-icon name="coins" scale="5"></v-icon>
                  </b-col>
                  <b-col md="12">
                    <p class="mb-2 py-0 text-center" style="font-size: 25px">
                      <strong>DINERO ACTUAL</strong>
                    </p>
                    <!-- <p><strong>Total: </strong>$ {{counter.total_actual_amount}}</p> -->
                    <p class="my-0 py-0">
                      <strong>Total: </strong>
                      ${{ counter.total_actual_amount }}
                    </p>
                    <p class="my-0 py-0">
                      <strong>Main account: </strong>
                      ${{ counter.main_account_actual_amount }}
                    </p>

                    <!-- <p class="my-0 py-0">
                      <strong>Small cap: </strong>
                      ${{ counter.small_cap.actual_amount }}
                    </p>

                    <p class="my-0 py-0">
                      <strong>Big account: </strong>
                      ${{ counter.big_account.actual_amount }}
                    </p> -->
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
        <b-col lg="4" class="mb-3">
          <b-card class="shadow" style="height: 100%;">
            <b-row>
              <b-col md="12">
                <b-row align-v="center">
                  <b-col md="12" class="text-center">
                    <v-icon name="coins" scale="5"></v-icon>
                  </b-col>
                  <b-col md="12">
                    <p class="mb-2 py-0 text-center" style="font-size: 23px"><strong>EARN/LOST</strong></p>

                    <p class="my-0 py-0">
                      <strong>Total ganancias: </strong>
                      {{ counter.earnings.total }}
                    </p>
                    <p class="my-0 py-0">
                      <strong>Producidas: </strong>
                      ${{ counter.earnings.earnings_amount }}
                    </p>
                     <p class="my-0 py-0">
                      <strong>Total pérdidas: </strong>
                      {{ counter.losses.total }}
                    </p>
                    <p class="my-0 py-0">
                      <strong>Producidas: </strong>
                     - ${{ counter.losses.amount }}
                    </p>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "Home",
  data() {
    return {
      progress: false,
      counter: null,
    };
  },
  mounted() {
    this.getAllCounters();
  },
  methods: {
    ...mapActions(["adminCounters"]),
    getAllCounters() {
      this.progress = true;
      this.adminCounters().then((response) => {
        if (response.code == 200) {
          this.progress = false;
          this.counter = response.data;
        }
      });
    },
  },
};
</script>
<style scoped>
.scroll {
  overflow: auto;
  overflow-x: hidden;

  max-height: 212px;
}
</style>